import { render } from "./ModalComponent .vue?vue&type=template&id=3ba6a96a&scoped=true"
import script from "./ModalComponent .vue?vue&type=script&lang=js"
export * from "./ModalComponent .vue?vue&type=script&lang=js"

import "./ModalComponent .vue?vue&type=style&index=0&id=3ba6a96a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba6a96a"]])

export default __exports__